var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    stroke: "#828292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8588 11.0499L13.7013 20.2399C12.5795 21.3658 11.0579 21.9983 9.47134 21.9983C7.8848 21.9983 6.36323 21.3658 5.24137 20.2399C4.11951 19.1141 3.48926 17.5871 3.48926 15.9949C3.48926 14.4027 4.11951 12.8758 5.24137 11.7499L14.3988 2.55992C15.1467 1.80936 16.1611 1.3877 17.2188 1.3877C18.2765 1.3877 19.2909 1.80936 20.0388 2.55992C20.7867 3.31048 21.2069 4.32846 21.2069 5.38992C21.2069 6.45138 20.7867 7.46936 20.0388 8.21992L10.8714 17.4099C10.4974 17.7852 9.99023 17.996 9.46138 17.996C8.93253 17.996 8.42534 17.7852 8.05139 17.4099C7.67744 17.0346 7.46735 16.5256 7.46735 15.9949C7.46735 15.4642 7.67744 14.9552 8.05139 14.5799L16.5113 6.09992",
    strokeWidth: 2.27565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/PaperClip.e4cb96d6.svg";
export { ForwardRef as ReactComponent };